import { render, staticRenderFns } from "./ContractDetailPriceChangeFilterControl.vue?vue&type=template&id=a0b7b934&"
import script from "./ContractDetailPriceChangeFilterControl.vue?vue&type=script&lang=js&"
export * from "./ContractDetailPriceChangeFilterControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
